export const schema = {
    properties: {
      actions: {
        type: 'object',
        title: 'Matter Summary',
        properties: {
          viewAction: {
            type: 'string',
            format: 'button',
            title: 'View',
            color: 'info'
          }
        }
      },
      id: {
        type: 'string',
        title: 'Id',
        hidden: true
      },
      reference: {
        type: 'string',
        title: 'Reference',
        sortable: true
      },
      description: {
        type: 'string',
        title: 'Description',
        sortable: true
      },
      openDate: {
        type: 'string',
        format: 'date',
        title: 'Open Date',
        sortable: true
      },
      lastUpdated: {
        type: 'string',
        format: 'date',
        title: 'Last Updated',
        sortable: true
      },
      archivedDate: {
        type: 'string',
        format: 'date',
        title: 'Closed Date',
        sortable: true,            
      },
      latestUpdate: {
        type: 'string',
        title: 'Last Completed Update',
        sortable: true,            
      },
      latestMilestone: {
        type: 'string',
        title: 'Last Completed Milestone',
        sortable: true,            
      },
      isUdModule:{
        type: 'string',
        title: 'isUdModule',
        hidden: true
      },
      udModuleUid:{
        type: 'string',
        title: 'udModuleUid',
        hidden: true
      },
      udModuleName:{
        type: 'string',
        title: 'udModuleName',
        hidden: true
      },
      masterProcessName:{
        type: 'string',
        title: 'masterProcessName',
        hidden: true
      },
      masterProcessId:{
        type: 'string',
        title: 'masterProcessId',
        hidden: true
      }
    }
  }
  